import { createContext, useContext } from 'react';
export const CalendarSlotContext = createContext({});
export const useCalendarSlotContext = ()=>useContext(CalendarSlotContext);
